<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-10-09 09:28:38
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-10-10 10:36:53
 * @FilePath: \ces-vue-serve\src\views\contractCommonInput\contractNumber.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          电子商务合同编号：
        </div>
        <div class="rj-baseinfo__item">
          {{ form.contractNum }}
        </div>
      </div>
    </div>
    <div class="rj-col-3">
      <div class="rj-baseinfo">
        <div class="rj-baseinfo__label">
          客户合同编号：
        </div>
        <div class="rj-baseinfo__item">
          <el-form-item prop="customerContractNum">
            <el-input v-model="form.customerContractNum" placeholder="客户合同编号" :disabled="isStatus" />
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { createContractNum } from '@/API';
let unitAbbreviation; // 代理商简称
export default {
  data () {
    return {
      // isStatus: true
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    isStatus: {
      type: Boolean,
      default: true
    },
    newContract: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    initData (val) {
      if (val) { unitAbbreviation = val; }
      if (!this.newContract) {
        this.newContract = '';
      }
      if (!this.form.isOrderAdminCreate) {
        this.form.isOrderAdminCreate = false;
      }
      if (this.form.contractType && unitAbbreviation) {
        // 接口请求合同号
        createContractNum(unitAbbreviation, this.form.contractType, this.newContract, this.form.isOrderAdminCreate).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$set(this.form, 'contractNum', json.data);
            // 如果不是新合同，在选择供货单位时，客户合同编号修改
            if (!this.form.isNewContract) {
              this.$set(this.form, 'customerContractNum', json.data);
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
